module.exports = __webpack_public_path__ + "media/images/masks/avatar-group-hover-2599daf761ff97bda7399c6415c1a254.svg";